import React, { Component } from "react";
import DashboardSection from "./DashboardSection/DashboardSection";
import DashboardFooter from "./DashboardFooter/DashboardFooter";
import Loading from "../Loading/Loading";
import "./DashboardHome.css";

class DashboardHome extends Component {
	componentWillMount() {
		// gets account info from session storage
		// request for recent searches and recent acquisitions
		this.accountInfo = this.props.refreshedAccountInfo();
		this.props.getRecentSearches();
		this.props.getRecentAcq();

		if (this.accountInfo === null) {
			window.location = "/404";
		}
	}
	formatDate(date) {
		if (date.includes('-')) {
			date = date + ' ';
		};

		var d = new Date(date),
			month = "" + (d.getMonth() + 1),
			day = "" + (d.getDate()),
			year = d
				.getFullYear()
				.toString();

		if (month.length < 2) month = "0" + month;
		if (day.length < 2) day = "0" + day;

		return [year, month, day].join("/");
	}
	
	onclick(data, endpoint) {
		this.props.resubmitSearchQuery(data, endpoint);
    }
   
	render() {
		let planName;

		if (this.accountInfo.planSettings["currentPlan"].length > 1) {
			planName = this.accountInfo.planSettings["currentPlan"]
				.join(" & ")
				.replace(/_/g, " ");
		} else {
			planName = this.accountInfo.planSettings["currentPlan"][0];
		}

		let renderRecentSearches = this.props.recentSearches.map((r, index) => {
			let data = r;
			let endpoint;
			let searchType = "";
			let query_str = "";
			let query_str0 = "";
			
			if (r.service.includes("recommend_acquiror")) {
				searchType = "acquirers";
				r.type= searchType;
				endpoint = "recommend_acquiror";
				query_str0= "Acquirers: | "; 
				query_str= "";

				if (r.acquiror_business) {
					query_str= query_str+ r.acquiror_business+ " | ";
				} 
				if (r.acquiror_location) {
					query_str= query_str+ r.acquiror_location+ " | ";
				} 
				if (r.acquiror_neighbor) {
					query_str= query_str+ r.acquiror_neighbor+ " | ";
				} 
				if (r.acquiror_financial) {
					query_str= query_str+ "Financial"+ " | ";
				} 
				if (r.acquiree_business) {
					query_str= query_str+ " Acquiree: "+r.acquiree_business+ " | ";
				} 
				
				if (query_str.length===0) {
					query_str= query_str0+"|";
				}
				else {
					query_str= query_str0+query_str;
				}
			} 
			
			
			else if (r.service.includes("find_company")) {
				searchType = "targets";
				r.type= searchType;
				endpoint = "find_company";
				query_str0= "Targets: | ";
				query_str="";
				
				if (r.company_business) {
					query_str= query_str+ r.company_business+ " | ";
				} 
				if (r.company_location) {
					query_str= query_str+ r.company_location+ " | ";
				} 
				if (r.company_neighbor) {
					query_str= query_str+ r.company_neighbor+ " | ";
				} 
				if (r.company_financial) {
					query_str= query_str+ "Financial"+ " | ";
				} 
				
				if (query_str.length==0) {
					query_str= query_str0+"|";
				}
				else {
					query_str= query_str0+query_str;
				}
			} 
			
			
			else if (r.service.includes("recommend_customer")) {
				searchType = "customers";
				r.type= searchType;
				endpoint = "recommend_customer";
				query_str0= "Customers: | ";
				query_str="";
				
				if (r.customer_business) {
					query_str= query_str+ r.customer_business+ " | ";
				} 
				if (r.customer_location) {
					query_str= query_str+ r.customer_location+ " | ";
				} 
				if (r.customer_neighbor) {
					query_str= query_str+ r.customer_neighbor+ " | ";
				} 
				if (r.customer_financial) {
					query_str= query_str+ "Financial"+ " | ";
				} 
				
				if (query_str.length==0) {
					query_str= query_str0+"|";
				}
				else {
					query_str= query_str0+query_str;
				}
			}

			else {
				searchType = "acquirers";
				r.type= searchType;
				endpoint = "recommend_acquiror";
				query_str= "Others: | |";
			}
			
			if (query_str.length> 100)
			   query_str= query_str.substring(0,100)+"...";
			
			return (
				searchType !== "" && (
					<div className="recent-search-container" key={index}>
						<div className="recent-search-content">
							<p
								className="recent-search-data"
								onClick={() =>
									this.onclick(data, `/service/financekb/${endpoint}`)}
							>
								{query_str}
							</p>
							<p className="recent-search-date">{this.formatDate(r.date)}</p>
						</div>
						<hr />
					</div>
				)
			);
		});

		let renderRecentAcq = this.props.recentAcq.map((r, index) => {
			return (
				<div className="recent-search-container" key={index}>
					<div className="recent-search-content">
						<p>
							<a
								className="recent-search-data"
								href={"http://"+r.url2}
								target="_blank"
								rel="noopener noreferrer"
							>
								{r.name2}
							</a>{" "}
							acquires{" "}
							<a
								className="recent-search-data"
								href={"http://"+r.url1}
								target="_blank"
								rel="noopener noreferrer"
							>
								{r.name1}
							</a>
						</p>
						<p className="recent-search-date">{r.date.split("-").join("/")}</p>
					</div>
					<hr />
				</div>
			);
		});

		return (
			<div className="dashboard-home-content container">
				{this.props.requestInProgress === true && <Loading />}
				<div className="dashboard-home-intro">
					{this.accountInfo.basicInformation["firstName"] ? (
						<h2>{`Welcome back, ${this.accountInfo.basicInformation[
							"firstName"
						]}!`}</h2>
					) : (
						<h2>Welcome back!</h2>
					)}
					{/*<p className="plan-name">{`${planName} Plan`}</p>*/}
				</div>
				<div className="dashboard-main-content">
					<DashboardSection
						sectionHeader={"Recent Searches"}
						data={this.props.recentSearches}
						renderBody={renderRecentSearches}
					/>
					<DashboardSection
						sectionHeader={"Recent Acquisitions"}
						data={this.props.recentAcq}
						renderBody={renderRecentAcq}
					/>
				</div>
				<DashboardFooter />
			</div>
		);
	}
}

export default DashboardHome;


// WEBPACK FOOTER //
// ./src/components/DashboardHome/DashboardHome.js